import {DecimalFieldWidget} from "../widgets/DecimalFieldWidget";
import {IntegerFieldWidget} from "../widgets/IntegerFieldWidget";

export function decimalColumnEditor(fieldMetadata, trimmedFieldId, grid) {
    return (container, options) => {
        let widget = new DecimalFieldWidget({owner: grid, fieldMetadata, cellOptions: options});
        widget.inputName = options.field;
        grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
    }
}

export function integerColumnEditor(fieldMetadata, trimmedFieldId, grid) {
    return (container, options) => {
        let widget = new IntegerFieldWidget({owner: grid, fieldMetadata, cellOptions: options});
        widget.inputName = options.field;
        grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
    }
}